import $ from 'jquery';

// The code is buggy so use CTRL+ESPACE to multiselect elements
// // Improve accessibility with custom select2
// let key = null;
// let isOpen = false;
// let previousValues = [];

// $('.select2-widget[multiple]').on('select2:open', function() {
//   setTimeout(() => {
//     isOpen = true;
//   }, 1);
// });
// $('.select2-widget[multiple]').on('select2:close', function() {
//   isOpen = false;
//   previousValues = [];
//   key = null;
// });

// window.addEventListener('keydown', (e) => {
//   const activeElement = document.activeElement;
//   const select2Container = activeElement.closest('.select2-container');
//   if (!select2Container) return;
//   const selectMultiple = select2Container.previousElementSibling;
//   if (!selectMultiple) return;

//   if (['Enter', 'Escape'].includes(e.key) && isOpen) {
//     key = e.key;
//     $(selectMultiple).select2('close');
//   }
// })

// $('.select2-widget[multiple]').on('select2:closing', function(e) {
//   const activeElement = document.activeElement;
//   if (!activeElement.classList.contains('select2-selection--multiple')) return;

//   const selectMultiple = e.target;


//   if (key === 'Escape') {
//     // prevent select2 to remove value
//     $(selectMultiple).val(previousValues).trigger('change');
//     return;
//   }

//   e.preventDefault();
//   const descendant = activeElement.getAttribute('aria-activedescendant');
//   if (!descendant) return;
//   const descendantEl = document.getElementById(descendant);
//   if (!descendantEl) return;
//   const descendantSplit = descendant.split('-');
//   const descendantId = descendantSplit[descendantSplit.length - 1];
//   const values = $(selectMultiple).select2('val');
//   if (!key || (key === 'Enter' && !previousValues.includes(descendantId))) {
//     previousValues = values;
//     return;
//   }

//   // use internal unselect method to force select2 to update
//   const instance = jQuery(selectMultiple).data().select2;
//   const data = instance.data().find((obj) => obj.id === descendantId);
//   if (typeof data !== 'undefined') {
//     instance.results.trigger('unselect', {
//       originalEvent: e,
//       data
//     });
//   }
//   key = null;
// });


// Custom styles for select2
window.addEventListener('load', () => {
  const selectsMultiple = document.querySelectorAll('select.select2-widget[multiple]');

  for (let index = 0; index < selectsMultiple.length; index++) {
    const selectMultiple = selectsMultiple[index];
    const select2 = selectMultiple.nextElementSibling;
    if (!select2) break;
    const select2Selection = select2.querySelector('.select2-selection--multiple');
    if (!select2Selection) break;
    const data = JSON.parse(selectMultiple.dataset.select2Config);
    const placeholder = data.placeholder;
    select2Selection.textContent = placeholder;
    select2Selection.tabIndex = '0';

    // update number
    const selected = Array.from(selectMultiple.querySelectorAll('option:checked'), (e) => e.value).length;
    if (selected > 0) {
      select2Selection.dataset.selected = selected.toString();
    }

    $(selectMultiple).on('change', () => {
      const selected = Array.from(selectMultiple.querySelectorAll('option:checked'), (e) => e.value).length;
      if (selected > 0) {
        select2Selection.dataset.selected = selected.toString();
      } else {
        select2Selection.removeAttribute('data-selected');
      }
      select2Selection.tabIndex = '0';
    })
  }
})
